import React, { PropsWithChildren } from 'react';
import { Form } from 'react-final-form';
import { ValidationErrors } from 'final-form';
import FooterForm from './FooterForm';
import { HeaderForm } from './HeaderForm';
import { WrapSection } from './Styled/AuthGroupCustom.styles';
// import Debug from '../../../../../../Components/Debug/Debug';

export type AuthFormLayoutProps<T> = PropsWithChildren<{
  title: string;
  initialValues: T;
  validate?: (
    values: T,
  ) => ValidationErrors | Promise<ValidationErrors> | undefined;
  submitFormHandler: (values: T) => Promise<any>;
  resetErrorsHandle: () => void;
}>;

export const AuthFormLayout = <T,>({
  title,
  children,
  initialValues,
  validate,
  submitFormHandler,
  resetErrorsHandle,
}: AuthFormLayoutProps<T>) => {
  return (
    <Form
      validateOnBlur={false}
      initialValues={initialValues}
      validate={validate}
      onSubmit={submitFormHandler}
      render={({ handleSubmit, submitting, form, pristine, invalid }) => (
        <form
          onSubmit={handleSubmit}
          onChange={() => {
            resetErrorsHandle();
          }}
        >
          <HeaderForm title={title} />

          <WrapSection>{children}</WrapSection>

          <FooterForm
            submitButtonDisabled={invalid || submitting || pristine}
            resetButtonDisabled={submitting || pristine}
            resetHandler={() => {
              resetErrorsHandle();
              form.reset();
            }}
          />

          {/*<Debug data={form.getState()} />*/}
        </form>
      )}
    />
  );
};
